var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralAvgclasssize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.318,
    height: 36.132,
    viewBox: "0 0 41.318 36.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "presentation",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55180",
    "data-name": "Path 55180",
    d: "M258.286,257.68a1.21,1.21,0,0,1-1.138-1.624l5.186-14.262a1.211,1.211,0,1,1,2.275.827l-5.186,14.262A1.211,1.211,0,0,1,258.286,257.68Zm0,0",
    transform: "translate(-236.331 -221.549)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55181",
    "data-name": "Path 55181",
    d: "M359.268,257.681a1.211,1.211,0,0,1-1.136-.793l-5.238-14.262a1.21,1.21,0,0,1,2.272-.835l5.238,14.262A1.211,1.211,0,0,1,359.268,257.681Zm0,0",
    transform: "translate(-324.347 -221.549)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55182",
    "data-name": "Path 55182",
    d: "M214.757,0H196.6a3.8,3.8,0,0,0-3.8,3.8V18.066a3.8,3.8,0,0,0,3.8,3.8h18.152a3.8,3.8,0,0,0,3.8-3.8V3.8a3.8,3.8,0,0,0-3.8-3.8Zm0,0",
    transform: "translate(-177.243)",
    fill: "#eff6fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55183",
    "data-name": "Path 55183",
    d: "M359.665,0H350.43V21.869h9.235a3.8,3.8,0,0,0,3.8-3.8V3.8a3.8,3.8,0,0,0-3.8-3.8Zm0,0",
    transform: "translate(-322.151)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55184",
    "data-name": "Path 55184",
    d: "M40.544,35.273A5.272,5.272,0,1,1,35.272,30,5.272,5.272,0,0,1,40.544,35.273Zm0,0",
    transform: "translate(-27.579 -27.579)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55185",
    "data-name": "Path 55185",
    d: "M233.634,153.374a1.211,1.211,0,0,1-.541-1.624l3.242-6.483a1.21,1.21,0,1,1,2.165,1.083l-3.242,6.483A1.211,1.211,0,0,1,233.634,153.374Zm0,0",
    transform: "translate(-214.165 -132.929)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55186",
    "data-name": "Path 55186",
    d: "M100.6,35.269a5.272,5.272,0,0,1-5.273,5.272V30a5.273,5.273,0,0,1,5.273,5.273Zm0,0",
    transform: "translate(-87.636 -27.575)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55187",
    "data-name": "Path 55187",
    d: "M271.242,58.659H258.276a1.21,1.21,0,0,1,0-2.421h12.966a1.21,1.21,0,0,1,0,2.421Zm0,0",
    transform: "translate(-236.321 -51.7)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48091",
    "data-name": "Group 48091",
    transform: "translate(28.279 4.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55188",
    "data-name": "Path 55188",
    d: "M357.071,122.921H351.64a1.21,1.21,0,1,1,0-2.421h5.431a1.21,1.21,0,1,1,0,2.421Zm0,0",
    transform: "translate(-350.429 -115.314)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55189",
    "data-name": "Path 55189",
    d: "M357.071,187.187H351.64a1.21,1.21,0,1,1,0-2.421h5.431a1.21,1.21,0,1,1,0,2.421Zm0,0",
    transform: "translate(-350.429 -174.394)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55190",
    "data-name": "Path 55190",
    d: "M357.071,56.238h-6.642v2.421h6.642a1.21,1.21,0,1,0,0-2.421Zm0,0",
    transform: "translate(-350.429 -56.238)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55191",
    "data-name": "Path 55191",
    d: "M11.583,183.833H3.8a1.21,1.21,0,0,1-1.21-1.21v-6.766A3.81,3.81,0,0,1,0,172.25v-3.89a7.632,7.632,0,0,1,2.255-5.441,7.733,7.733,0,0,1,5.438-2.252h1.07c2.123,0,3.368.778,5.112,1.645,1.921.955,4.317,2.147,5.845,2.908a3.15,3.15,0,0,1,1.578,3.832l0,.014a3.316,3.316,0,0,1-4.625,1.894l-3.875-1.937v13.6a1.211,1.211,0,0,1-1.211,1.21Zm0,0",
    transform: "translate(0 -147.702)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55192",
    "data-name": "Path 55192",
    d: "M107.356,165.221c-1.528-.761-3.925-1.953-5.846-2.908-1.744-.867-2.988-1.645-5.112-1.645h-1.07v23.166h3.89a1.21,1.21,0,0,0,1.21-1.21v-13.6l3.875,1.937a3.316,3.316,0,0,0,4.625-1.894l0-.014a3.15,3.15,0,0,0-1.578-3.831Zm0,0",
    transform: "translate(-87.635 -147.702)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralAvgclasssize);
export default __webpack_public_path__ + "static/media/university-general-avgclasssize.415cc85607f497f3ad89fe30c40bd149.svg";
export { ForwardRef as ReactComponent };